export const types = {
  ON_CHANGE_SYSTEM_MODAL: 'ON_CHANGE_SYSTEM_MODAL',
  ON_DISPLAY_SYSTEM_MODAL: 'ON_DISPLAY_SYSTEM_MODAL',

  ON_CHANGE_SYSTEM_TOAST: 'ON_CHANGE_SYSTEM_TOAST',
  ON_DISPLAY_SYSTEM_TOAST: 'ON_DISPLAY_SYSTEM_TOAST',

  ON_INITIALIZE_SYSTEM_FULFILLED: 'ON_INITIALIZE_SYSTEM_FULFILLED',
  ON_INITIALIZE_SYSTEM_PENDING: 'ON_INITIALIZE_SYSTEM_PENDING',
  ON_INITIALIZE_SYSTEM_REJECTED: 'ON_INITIALIZE_SYSTEM_REJECTED',

  ON_HISTORY_LISTEN: 'ON_HISTORY_LISTEN',

  ON_FIRST_LOGIN: 'ON_FIRST_LOGIN'
};

const onChangeSystemModal = ({ modalContent }) => dispatch =>
  dispatch({
    type: types.ON_CHANGE_SYSTEM_MODAL,
    data: modalContent
  });

const onDisplaySystemModal = ({ show }) => dispatch =>
  dispatch({
    type: types.ON_DISPLAY_SYSTEM_MODAL,
    data: show
  });

export const onHideSystemModal = () => dispatch =>
  dispatch(onDisplaySystemModal({ show: false }));

export const onShowSystemModal = ({ modalContent }) => dispatch => {
  dispatch(onDisplaySystemModal({ show: true }));
  dispatch(onChangeSystemModal({ modalContent }));
};

const onChangeSystemToast = ({ toastMessage }) => dispatch =>
  dispatch({
    type: types.ON_CHANGE_SYSTEM_TOAST,
    data: toastMessage
  });

const onDisplaySystemToast = ({ show }) => dispatch =>
  dispatch({
    type: types.ON_DISPLAY_SYSTEM_TOAST,
    data: show
  });

export const onHideSystemToast = () => dispatch =>
  dispatch(onDisplaySystemToast({ show: false }));

export const onShowSystemToast = ({ toastMessage }) => dispatch => {
  dispatch(onDisplaySystemToast({ show: true }));
  dispatch(onChangeSystemToast({ toastMessage }));
};

export const onHistoryListen = (props = {}) => dispatch => {
  const { location, action, onHistoryListenCallback } = props;

  dispatch({
    type: types.ON_HISTORY_LISTEN
  });

  dispatch(onHistoryListenCallback(location, action));

  window.scrollTo(0, 0);
};

/**
 * First Login
 */
export const onFirstLogin = (props = {}) => {
  const { notFirstLogin } = props;

  return {
    data: notFirstLogin,
    type: types.ON_FIRST_LOGIN
  };
};

const onInitializeSystemFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_INITIALIZE_SYSTEM_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onInitializeSystemRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_INITIALIZE_SYSTEM_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onInitializeSystem = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_INITIALIZE_SYSTEM_PENDING
  });

  const { onInitializeSystemCallback, fulfillCallback, rejectCallback } = props;

  const errorMessage = 'System initialize failed';
  const successMessage = 'System initialize successfull';

  return (
    onInitializeSystemCallback &&
    dispatch(onInitializeSystemCallback())
      .then(() =>
        dispatch(
          onInitializeSystemFulfilled({
            fulfillCallback,
            message: successMessage,
            status: 200
          })
        )
      )
      .catch(() =>
        dispatch(
          onInitializeSystemRejected({
            rejectCallback,
            message: errorMessage,
            status: 400
          })
        )
      )
  );
};



// WEBPACK FOOTER //
// ./src/qoc-redux/System/actions.js